import { useState } from 'react';

export default function Hero() {
  const [showAppModal, setShowAppModal] = useState(false);

  const scrollToProducts = () => {
    const productsSection = document.getElementById('products');
    if (productsSection) {
      productsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* 背景视频 */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src="https://public.readdy.ai/ai/video_res/dcd0fa26-1002-4783-96d7-6392bb5ff343.mp4" type="video/mp4" />
      </video>
      
      {/* 背景遮罩 */}
      <div className="absolute inset-0 bg-gradient-to-r from-white/90 via-white/70 to-white/60"></div>
      
      <div className="relative z-10 w-full px-6 lg:px-32 max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* 左侧内容 */}
          <div className="text-left">
            {/* 品牌核心价值主张 */}
            <h1 className="text-3xl lg:text-7xl font-light text-gray-800 mb-6 lg:mb-8 leading-tight">
              轻松一点，
              <br />
              <span className="text-[#847eba]">才轻一点</span>
            </h1>
            
            {/* 品牌使命 */}
            <p className="text-sm lg:text-2xl text-gray-700 mb-6 lg:mb-8 font-light leading-relaxed">
              通过科学、有趣、无压力的产品与体验，
              <br />
              帮助用户从内到外获得身体的轻盈和心理的轻松
            </p>
            
            {/* 品牌核心理念 */}
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-4 lg:p-8 mb-8 lg:mb-12 shadow-lg border border-white/20">
              <p className="text-xs lg:text-lg text-gray-600 leading-relaxed font-light">
                不再贩卖身材的"焦虑"，而是倡导身体和心理的"快乐"；
                <br />
                不再强调"快结果"，而是赋能"轻过程"。
              </p>
            </div>
            
            {/* CTA按钮组 */}
            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={scrollToProducts}
                className="inline-flex items-center justify-center px-6 lg:px-10 py-3 lg:py-4 bg-[#847eba] text-white hover:bg-[#6b5d9a] transition-all duration-300 rounded-full text-sm lg:text-base font-medium whitespace-nowrap cursor-pointer group shadow-lg"
              >
                开启轻松之旅
                <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform duration-300"></i>
              </button>
              
              <button 
                onClick={() => window.REACT_APP_NAVIGATE('/about')}
                className="inline-flex items-center justify-center px-6 lg:px-10 py-3 lg:py-4 border-2 border-[#847eba] text-[#847eba] hover:bg-[#847eba] hover:text-white focus:bg-[#847eba] focus:text-white focus:outline-none focus:ring-2 focus:ring-[#847eba]/50 focus:ring-offset-2 transition-all duration-300 rounded-full text-sm lg:text-base font-medium whitespace-nowrap cursor-pointer"
              >
                了解品牌故事
              </button>
            </div>
          </div>

          {/* 右侧品牌标识区域 */}
          <div className="hidden lg:flex justify-center items-center">
            <div className="relative">
              {/* 装饰性衬线 */}
              <div className="absolute -top-8 -left-8 w-16 h-16 border-l-2 border-t-2 border-[#847eba]/20 rounded-tl-lg"></div>
              <div className="absolute -bottom-8 -right-8 w-16 h-16 border-r-2 border-b-2 border-[#a3c1c3]/20 rounded-br-lg"></div>
              <div className="absolute top-4 right-4 w-2 h-2 bg-[#847eba]/30 rounded-full"></div>
              <div className="absolute bottom-4 left-4 w-3 h-3 bg-[#a3c1c3]/30 rounded-full"></div>
              
              {/* 网格背景 */}
              <div className="absolute inset-0 opacity-10" style={{
                backgroundImage: `linear-gradient(#847eba 1px, transparent 1px), linear-gradient(90deg, #847eba 1px, transparent 1px)`,
                backgroundSize: '20px 20px'
              }}></div>
              
              {/* Logo */}
              <div className="bg-white/90 backdrop-blur-sm rounded-3xl p-12 shadow-2xl border border-white/40">
                <img 
                  src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/58ab3c2c100cfeefc13e4dde60a3c9a8.png"
                  alt="燃轻元"
                  className="h-32 w-auto object-contain mx-auto"
                />
                <p className="text-center text-gray-600 mt-4 font-light text-sm">
                  科学之下的轻松哲学
                </p>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* APP下载弹窗 */}
      {showAppModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-gradient-to-br from-[#847eba] to-[#6b5d9a] rounded-3xl p-6 lg:p-8 max-w-sm w-full relative shadow-2xl">
            {/* 关闭按钮 */}
            <button 
              onClick={() => setShowAppModal(false)}
              className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-white/70 hover:text-white hover:bg-white/10 rounded-full transition-all duration-200"
            >
              <i className="ri-close-line text-lg"></i>
            </button>
            
            <div className="text-center text-white">
              {/* APP图标 */}
              <div className="mb-4 lg:mb-6">
                <div className="w-20 h-20 lg:w-24 lg:h-24 mx-auto relative">
                  {/* iPhone 4风格APP图标 */}
                  <div className="w-full h-full bg-gradient-to-b from-gray-100 to-gray-300 rounded-[22%] shadow-lg border border-gray-200/50 relative overflow-hidden">
                    {/* 哈乐猴IP主体 */}
                    <div className="absolute inset-2 flex flex-col items-center justify-center">
                      {/* 哈乐猴形象 */}
                      <div className="w-8 h-8 lg:w-10 lg:h-10 mb-1">
                        <img 
                          src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/56bd2c424ca5fcbf472311441b3e29fd.png"
                          alt="哈乐猴"
                          className="w-full h-full object-contain"
                        />
                      </div>
                      {/* 燃轻元文字 */}
                      <div className="text-gray-700 font-medium text-[8px] lg:text-[10px] leading-tight text-center">
                        燃轻元
                      </div>
                    </div>
                    {/* iPhone 4经典光泽效果 */}
                    <div className="absolute inset-0 bg-gradient-to-b from-white/40 via-white/10 to-transparent rounded-[22%]"></div>
                    <div className="absolute top-0 left-0 right-0 h-1/3 bg-gradient-to-b from-white/30 to-transparent rounded-t-[22%]"></div>
                    {/* 细微内阴影 */}
                    <div className="absolute inset-0 rounded-[22%] shadow-inner"></div>
                  </div>
                </div>
              </div>

              <h3 className="text-xl lg:text-2xl font-semibold mb-2">哈乐猴</h3>
              <p className="text-white/90 text-sm lg:text-base mb-4 lg:mb-6">扫码下载APP</p>
              
              {/* 二维码 */}
              <div className="bg-white rounded-2xl p-4 mb-4 lg:mb-6 inline-block">
                <div className="w-32 h-32 lg:w-40 lg:h-40 bg-gray-100 rounded-xl flex items-center justify-center">
                  <img 
                    src="https://public.readdy.ai/ai/img_res/7a50a8b71bcc31fa40d67e1552e063b2.jpg"
                    alt="下载二维码"
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
              
              {/* 下载按钮 */}
              <div className="flex flex-col gap-3">
                <button className="bg-white text-gray-800 py-2.5 lg:py-3 px-4 lg:px-6 rounded-full font-medium hover:bg-gray-50 transition-colors duration-200 flex items-center justify-center gap-2 text-sm lg:text-base">
                  <i className="ri-apple-line text-lg"></i>
                  App Store
                </button>
                <button className="bg-white text-gray-800 py-2.5 lg:py-3 px-4 lg:px-6 rounded-full font-medium hover:bg-gray-50 transition-colors duration-200 flex items-center justify-center gap-2 text-sm lg:text-base">
                  <i className="ri-google-play-line text-lg"></i>
                  Google Play
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
